import React from "react";
import * as SubframeCore from "@subframe/core";
import { Button } from "../../../ui/components/Button";
import { DropdownMenu } from "../../../ui/components/DropdownMenu";
import { FeatherChevronDown } from "@subframe/core";

export interface SortOption {
  value: string;
  label: string;
  by: string;
  order: string;
}

interface SortDropdownProps {
  currentSort: {
    by: string;
    order: string;
    label: string;
  };
  onSortChange: (sortBy: string, sortOrder: string, label: string) => void;
  options?: SortOption[];
  disabled?: boolean;
  variant?: "neutral-tertiary" | "neutral-secondary" | "brand-primary";
  size?: "small" | "medium" | "large";
}

const DEFAULT_SORT_OPTIONS: SortOption[] = [
  {
    value: "created_at_desc",
    label: "Created Date: Newest First",
    by: "created_at",
    order: "desc",
  },
  {
    value: "created_at_asc",
    label: "Created Date: Oldest First",
    by: "created_at",
    order: "asc",
  },
  {
    value: "updated_at_desc",
    label: "Modified Date: Newest First",
    by: "updated_at",
    order: "desc",
  },
  {
    value: "updated_at_asc",
    label: "Modified Date: Oldest First",
    by: "updated_at",
    order: "asc",
  },
];

export const SortDropdown: React.FC<SortDropdownProps> = ({
  currentSort,
  onSortChange,
  options = DEFAULT_SORT_OPTIONS,
  disabled = false,
  variant = "neutral-tertiary",
  size,
}) => {
  return (
    <SubframeCore.DropdownMenu.Root>
      <SubframeCore.DropdownMenu.Trigger asChild={true}>
        <Button
          variant={variant}
          iconRight={<FeatherChevronDown />}
          disabled={disabled}
          size={size}
        >
          Sort: {currentSort.label}
        </Button>
      </SubframeCore.DropdownMenu.Trigger>
      <SubframeCore.DropdownMenu.Portal>
        <SubframeCore.DropdownMenu.Content
          side="bottom"
          align="end"
          sideOffset={8}
          asChild={true}
        >
          <DropdownMenu>
            {options.map((option) => (
              <DropdownMenu.DropdownItem
                key={option.value}
                icon={null}
                onClick={() => {
                  onSortChange(option.by, option.order, option.label);
                }}
              >
                {option.label}
              </DropdownMenu.DropdownItem>
            ))}
          </DropdownMenu>
        </SubframeCore.DropdownMenu.Content>
      </SubframeCore.DropdownMenu.Portal>
    </SubframeCore.DropdownMenu.Root>
  );
};

export default SortDropdown;
